import { useMemo, useCallback } from "react";
import { useContextShoppingCart } from "../module/index";
import { ProductCostItemType, MarketplaceCartItemType } from "@/schemas/index";

export function useShoppingCart() {
  const {
    marketplaceCartCount,
    marketplaceCartData,
    fetchShoppingCart,
    fetchAddProductToCart,
    fetchRemoveItemCart,
    fetchReduceItemCart,
    fetchIncreaseItemCart,
  } = useContextShoppingCart();

  const addProduct = useCallback(
    (costId: ProductCostItemType["Id"], quantity: number = 1) =>
      fetchAddProductToCart(costId, quantity),
    [fetchAddProductToCart],
  );

  const increase = useCallback(
    (itemId: MarketplaceCartItemType["Id"]) => fetchIncreaseItemCart(itemId),
    [fetchIncreaseItemCart],
  );

  const reduce = useCallback(
    (itemId: MarketplaceCartItemType["Id"]) => fetchReduceItemCart(itemId),
    [fetchReduceItemCart],
  );

  const remove = useCallback(
    (itemId: MarketplaceCartItemType["Id"]) => fetchRemoveItemCart(itemId),
    [fetchRemoveItemCart],
  );

  const fetchData = useMemo(() => fetchShoppingCart, [fetchShoppingCart]);

  return useMemo(
    () => ({
      total: marketplaceCartCount,
      data: marketplaceCartData,
      addProduct,
      remove,
      increase,
      reduce,
      fetchData,
    }),
    [
      addProduct,
      remove,
      increase,
      reduce,
      fetchData,
      marketplaceCartData,
      marketplaceCartCount,
    ],
  );
}
